"use client";

import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ParticleField } from "@/components/ui/particle-field";
import { GlowOrb } from "@/components/ui/glow-orb";
import { siteConfig } from "@/lib/data/site";

export function CtaSection() {
  return (
    <section className="relative overflow-hidden py-20 sm:py-24 md:py-32">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,var(--hero-glow-1),transparent_55%)]" />
      <GlowOrb className="left-1/4 top-0" color="accent" size={380} />
      <GlowOrb className="right-1/5 bottom-0" color="cyan" size={300} delay={1.2} />
      <ParticleField className="opacity-50" density={40} />
      <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-accent to-transparent" />
      <div className="container-wide relative">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.75, ease: [0.22, 1, 0.36, 1] }}
          className="relative mx-auto max-w-4xl overflow-hidden rounded-[2rem] border border-border bg-card/50 px-6 py-12 text-center shadow-[var(--shadow-soft)] backdrop-blur-xl sm:px-10 sm:py-16 md:rounded-[2.5rem]"
        >
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-accent/10 via-transparent to-cyan/10" />
          <p className="eyebrow relative mb-6 justify-center">Private briefing</p>
          <h2 className="display-title relative text-4xl sm:text-5xl md:text-6xl lg:text-7xl">
            READY TO BUILD
            <br />
            <span className="gradient-text">WITH INTENT.</span>
          </h2>
          <p className="relative mx-auto mt-6 max-w-xl text-base text-muted sm:text-lg">
            Share your ambition, constraints, and timeline. We respond with a clear discovery plan —
            not a generic pitch deck.
          </p>
          <div className="relative mt-9 flex flex-col items-center justify-center gap-3 sm:mt-10 sm:flex-row">
            <Button href="/contact" size="lg" variant="secondary" arrow cursorLabel="START" className="w-full sm:w-auto">
              Request a briefing
            </Button>
            <Button href={`mailto:${siteConfig.email}`} size="lg" variant="outline" cursorLabel="EMAIL" className="w-full sm:w-auto">
              Email Maxridge
            </Button>
          </div>
          <p className="relative mt-6 text-xs uppercase tracking-[0.16em] text-muted">
            Typical response within one business day
          </p>
        </motion.div>
      </div>
    </section>
  );
}
